import { EServiceType } from "@/models/interfaces/Orders/EServiceType";
import * as moment from "moment";
import { forEach, map, reduce, invert, filter, capitalize } from 'lodash';
import DateManipulator from "./DateManipulator";
// TODO move to relevant util files
export function printCompactedOptions(options) {
    var displayOptionTxt = "";
    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
        var option = options_1[_i];
        displayOptionTxt += option.name + ": ";
        for (var i = 0; i < option.choices.length; i++) {
            displayOptionTxt += "" + option.choices[i].name;
            if (i < option.choices.length - 1) {
                displayOptionTxt += ", ";
            }
        }
        displayOptionTxt += "; ";
    }
    return displayOptionTxt;
}
export function getParam(param, url) {
    if (url === void 0) { url = location.search; }
    param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
    var results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
export function splitName(name) {
    var names = name.split(" ");
    var fullName = {
        firstName: null,
        lastName: null
    };
    if (names[0]) {
        fullName.firstName = names[0];
    }
    else {
        return false;
    }
    if (1 < names.length) {
        fullName.lastName = names.slice(1).join(" ");
    }
    else {
        fullName.lastName = "";
    }
    return fullName;
}
export function formify(obj) {
    var formData = new FormData();
    Object.keys(obj).forEach(function (key) { return formData.append(key, obj[key]); });
    return formData;
}
export var delayCall = function (delayedFunction) { return setTimeout(function () {
    delayedFunction();
}, 0); };
export function extractOrderId(orderId) {
    if (orderId) {
        var padder = "0";
        var splitId = orderId.substr(orderId.indexOf("-") + 1).slice(-4);
        return padder.repeat(4 - splitId.length) + splitId;
    }
}
export function getServiceTypeName(serviceType) {
    return (serviceType === EServiceType.SERVICE_TYPE_DELIVERY) ? "Delivery" : "Pickup";
}
export function siblingIdFromName(siblingName) {
    var siblingMap = {
        whole: '0',
        left: '1',
        right: '2',
    };
    return siblingMap[siblingName];
}
export function siblingNameFromId(siblingId) {
    var siblingMap = {
        whole: '0',
        left: '1',
        right: '2',
    };
    var invertMap = invert(siblingMap);
    return invertMap[siblingId];
}
// TODO this assumes highest price sibling
export function determineSiblingUsed(totals) {
    var siblingUsed = '0';
    var counts = {};
    var counter = 0;
    forEach(totals, function (total, sibling) {
        var choices = map(total, function (optionChoices) {
            var filterChoices = filter(optionChoices, function (choice) {
                if (choice.included) {
                    return false;
                }
                return true;
            });
            return filterChoices.length;
        });
        counter = reduce(choices, function (accumulator, count) {
            return accumulator + count;
        }, 0);
        counts[sibling] = counter;
    });
    var whole = counts['whole'];
    counts['left'] += whole;
    counts['right'] += whole;
    var high = Math.max(counts['whole'], counts['left'], counts['right']);
    var countsInvert = invert(counts);
    siblingUsed = siblingIdFromName(countsInvert[high]);
    return siblingUsed;
}
export function generateUniqueId(id) {
    if (id === void 0) { id = ""; }
    if (id) {
        id += "-";
    }
    var random = parseInt((Math.random() * 10000).toString());
    var unixTime = moment().unix();
    return "" + id + random + "-" + unixTime;
}
export function calculateTotal(totals) {
    var grandTotal = 0;
    for (var key in totals) {
        if (key !== "collected") {
            if (key === "discount" || key === "refund") {
                grandTotal -= totals[key];
            }
            else {
                grandTotal += totals[key];
            }
        }
    }
    return grandTotal;
}
// TODO move to service
export function findNextAvailableTime(location) {
    for (var _i = 0, _a = location.locationHours; _i < _a.length; _i++) {
        var dayObj = _a[_i];
        if (!dayObj.isClosed) {
            var roundToFifteen = DateManipulator.roundMomentTo15Min(moment());
            var startTime = moment(dayObj.startTime);
            var maxTime = moment.max(roundToFifteen, startTime);
            if (maxTime.isBefore(dayObj.endTime)) {
                return moment(maxTime);
            }
        }
    }
    return moment();
}
export function lightenDarkenHex(color, percent) {
    var f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
    return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}
export function isNumeric(val) {
    return typeof val === 'number';
}
export function isSmallScreen() {
    if (window && window.screen) {
        var availableWidth = window.screen.availWidth;
        return (availableWidth <= 340);
    }
    // default
    return false;
}
export function reverseVanityName(name) {
    var dehyphenate = name.replace(/\-+/g, ' ');
    var words = dehyphenate.split(' ');
    var capitalizedWords = map(words, function (word) {
        return capitalize(word);
    });
    return capitalizedWords.join(' ');
}
export function generateFullAddress(_address, _apt) {
    var address = _address;
    var apt = _apt;
    if (apt) {
        var addressParts = address.split(',');
        var streetAddress = addressParts.shift();
        var aptFormatted = "#" + apt;
        if (streetAddress.indexOf(aptFormatted) === -1) {
            streetAddress = streetAddress + " " + aptFormatted;
        }
        addressParts.unshift(streetAddress);
        address = addressParts.join(',');
    }
    return address;
}
export function hasNewCustomerName(firstName, lastName) {
    return firstName.toLowerCase() === "online" && lastName.toLowerCase() === "customer";
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/helper.functions.ts
// module id = tdEi
// module chunks = 18